import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { MultiSizePopup } from "../../UIToolkit/Popups/MultiSizePopup/MultiSizePopup";
import { MAX_CONTENT_WIDTH, MAX_MINIMIZED_CONTENT_HEIGHT, SCHEDULE_EXPORT_TEST_ID } from "./consts";
import { ScheduleExportBody } from "./ScheduleExportBody";

export type ScheduleExportPopupProps = {
	open: boolean;
	onClose: () => void;
	weekIndex: number;
};

export const ScheduleExportPopup: FC<ScheduleExportPopupProps> = ({ open, onClose, weekIndex }) => {
	const { t } = useTranslation();

	return (
		<MultiSizePopup
			data-testid={`${SCHEDULE_EXPORT_TEST_ID}-dialog`}
			open={open}
			onClose={onClose}
			title={t("download.schedule.title")}
			maxContentWidth={MAX_CONTENT_WIDTH}
			minimizedMaxContentHeight={MAX_MINIMIZED_CONTENT_HEIGHT}
			closeOnEscape
			// Hiding must not throw away the range the user picked.
			keepBodyMounted
			// The body gets the state in full, not a minimized flag: with `keepBodyMounted` the popup hands
			// it every state including HIDDEN, so only the body can tell hiding apart from minimizing.
			bodyRenderer={(sizeState) => <ScheduleExportBody sizeState={sizeState} weekIndex={weekIndex} onClose={onClose} />}
		/>
	);
};
